// extracted by mini-css-extract-plugin
export default {"container":"ModalCloseButton--container--588e66"};